<script lang="ts">
  export let challengeTitle: string = "The Challenge";
  export let challengeText: string;
  export let solutionTitle: string = "The Solution";
  export let solutionText: string;
  export let className: string = "";
  import { reveal } from 'svelte-reveal';
  import ScrambleIn from './ScrambleIn.svelte';
</script>

<div class={`grid grid-cols-1 md:grid-cols-2 gap-12 ${className}`} use:reveal={{ blur: .5 }}>
  <div class="p-8 rounded-xl bg-orange-500 shadow relative">
    <div class="relative z-10">
      <h2 class="text-xl font-light mb-4 text-white">
        <ScrambleIn text={challengeTitle} className="text-xl font-light" scrambleSpeed={100} />
      </h2>
      <p class="text-base text-white">{challengeText}</p>
    </div>
  </div>
  <div class="p-8 rounded-xl bg-blue-100 shadow relative" use:reveal={{ blur: 0.5 }}>
    <div class="relative z-10">
      <h2 class="text-xl font-light mb-4">
        <ScrambleIn text={solutionTitle} className="text-xl font-light" scrambleSpeed={100} />
      </h2>
      <p class="mb-8 text-base text-gray-700">{solutionText}</p>
    </div>
  </div>
</div> 